import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GenericCrudComponent } from '../../../shared/components/generic-crud/generic-crud.component';

@Component({
  selector: 'app-products',
  standalone: true,
  imports: [RouterOutlet, GenericCrudComponent],
  templateUrl: './products.component.html',
  styleUrl: './products.component.css'
})
export class ProductsComponent {

}
